// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { genericTelemetryClickDispatcher, getPageContentType } from "../Social.telemetry";

export interface MultiLoginPageTelemetryObjects {
    main: TelemetryObjectBase;
    loginMicrosoft: TelemetryObjectBase;
    loginGoogle: TelemetryObjectBase;
    loginFacebook: TelemetryObjectBase;
}

export const multiLoginPageTelemetryContracts = {
    /**
     * Comments-Scenario 4b
     * */
    main: {
        name: "LoginSelectMethod",
        content: {
            type: getPageContentType()
        }
    },
    /** Comments-Scenario 4ci */
    loginMicrosoft: {
        name: "ContinueWithMicrosoft",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "ContinueWithMicrosoft"
        }
    },
    /** Comments-Scenario 4cii */
    loginGoogle: {
        name: "ContinueWithGoogle",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "ContinueWithGoogle"
        }
    },
    /** Comments-Scenario 4cii */
    loginFacebook: {
        name: "ContinueWithFacebook",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "ContinueWithFacebook"
        }
    }
};

export const multiLoginPageTelemetryActionDispatchers = {
    genericClick: genericTelemetryClickDispatcher
};